import { ErrorIcon, EyeHiddenIcon, EyeIcon } from '@/components/icons'
import {
  FormHelperText,
  IconButton,
  InputAdornment,
  Stack,
} from '@mui/material'
import { formHelperTextClasses } from '@mui/material/FormHelperText'
import InputBase, {
  InputBaseProps,
  inputBaseClasses,
} from '@mui/material/InputBase'
import React, { Fragment, useState } from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
interface PasswordFieldProps extends InputBaseProps {
  name: string
  form: UseFormReturn<any, any>
  placeholder?: string
  showErrorMessage: boolean
  onFocus?: () => void
  onBlur?: () => void
  login?: boolean
}

const PasswordField = ({
  name,
  form,
  placeholder,
  showErrorMessage,
  onFocus,
  onBlur,
  login,
  ...props
}: PasswordFieldProps) => {
  const [isShowPassword, setIsShowPassword] = useState(false)
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault()
  }
  const {
    control,
    watch,
    formState: { errors },
  } = form

  return (
    <Fragment>
      <Controller
        render={({ field }) => (
          <InputBase
            autoComplete="off"
            placeholder={placeholder}
            sx={{
              paddingRight: '16px',
              backgroundColor: !!errors[name]
                ? 'error.main'
                : login
                ? '#fff'
                : 'background.overrideDefault',
              height: '40px',
              width: '100%',
              border: '1px solid #F1F1F1',
              color: !!errors[name] ? '#000' : login ? '#000' : 'text.main',
              [`& .${inputBaseClasses.input}::placeholder`]: {
                opacity: 1,
                color: !!errors[name] ? '#000' : 'inherit',
              },
              [`& .${inputBaseClasses.input}`]: {
                padding: '0px 16px',
                height: '100%',
                borderRadius: '4px',
                MozAppearance: 'textfield',
              },
              borderRadius: '4px',
              '&:hover': {
                border: '1px solid',
                borderColor:
                  !!errors[name] &&
                  watch('confirm_password') !== watch('new_password')
                    ? 'error.main'
                    : 'inherit',
                backgroundColor: !!errors[name]
                  ? 'error.main'
                  : login
                  ? '#fff'
                  : 'background.overrideDefault',
              },
              [`&.${inputBaseClasses.focused}`]: {
                border: '1px solid ',
                borderColor:
                  !!errors[name] &&
                  watch('confirm_password') !== watch('new_password')
                    ? 'error.main'
                    : 'inherit',
                backgroundColor: !!errors[name]
                  ? 'error.main'
                  : login
                  ? '#fff'
                  : 'background.overrideDefault',
              },
              borderColor: !!errors[name] ? 'error.main' : '#F1F1F1',
            }}
            id={name}
            type={isShowPassword ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setIsShowPassword((oldData) => !oldData)}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {isShowPassword ? (
                    <EyeIcon fontSize="small" sx={{ color: 'grey.600' }} />
                  ) : (
                    <EyeHiddenIcon
                      fontSize="small"
                      sx={{ color: 'grey.600' }}
                    />
                  )}
                </IconButton>
              </InputAdornment>
            }
            {...field}
            {...props}
            onFocus={onFocus}
            onBlur={onBlur}
          />
        )}
        name={name}
        control={control}
      />

      {showErrorMessage && errors[name] && (
        <Stack direction="row" spacing="5px" mt="3px" color="#FF3030">
          <ErrorIcon />
          <FormHelperText
            error
            sx={{
              width: '100%',
              fontSize: '12px',
              fontWeight: '400',
              lineHeight: '115%',
              marginLeft: '9px',
              flex: 'none',
              letterSpacing: '0.045em',
              [`&.${formHelperTextClasses.error}`]: {
                color: 'text.main',
                marginLeft: '9px',
                pr: '24px',
                marginTop: '1px',
              },
            }}
          >
            {errors[name]?.message as string}
          </FormHelperText>
        </Stack>
      )}
    </Fragment>
  )
}

export default PasswordField
